export const compareItem = <T>(item1: T, item2: T, ascending: boolean = true, onEqual: undefined | (() => number) = undefined) => {
    if (item1 < item2) {
        return ascending ? -1 : 1;
    }

    if (item2 < item1) {
        return ascending ? 1 : -1;
    }

    if (onEqual) {
        return onEqual();
    }

    return 0;
};